<script>
  export let left = false
  export let right = false
</script>

{#if left}
  <svg width="33" height="62" viewBox="0 0 33 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M32 1L2 31L32 61"  stroke-width="2"/>
  </svg>
{/if}
{#if right}
  <svg width="33" height="62" viewBox="0 0 33 62" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M0.999999 61L31 31L1 0.999996"  stroke-width="2"/>
  </svg>
{/if}

<style lang="scss">
  path {
    stroke: $color-mint;
  }
</style>